import { Container } from '@mui/material';
import { styled } from '@mui/styles';


export const StyledDetailsContainerDesktop = styled(Container)(({ theme }) => ({
    paddingTop: '40px',
    '& .ImageBox': {
        border: '1px solid #eee', 
        borderRadius: '15px', 
        '& span': 
        { 
            width: '100%', 
            height: '450px',
            '& img': {
                borderRadius: '15px', 
                width: '100%', 
                height: '100%', 
                objectFit: 'cover'
            }
        }
    },
    '& .Title': {
        fontSize: '20px'
    },
    '& .WhatsIncludedSection': {
        '& .MuiAccordionSummary-root': {
            backgroundColor: theme.palette.neutral.light,
            borderRadius: '5px'
        },

        '& .MuiPaper-root': {
            boxShadow: 'unset',
            marginTop: '1rem'
        },

        '& .AccordionItems': {
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: '24px',
            marginTop: '16px',

            [theme.breakpoints.down('md')]: {
                gap: '10px'    
            },

            '& .Item': {
                flexBasis: '48%',
                gap: '8px',
                flexDirection: 'row',
            }
        }
    },
    '& .EventFAQsSection': {
        '& .MuiPaper-root': {
            boxShadow: 'unset',
        },
        '& .MuiAccordionSummary-content p': {
            fontWeight: 700
        },
        '& .MuiAccordionDetails-root': {
            [theme.breakpoints.down('sm')]: {
                maxWidth: '300px'
            }
        },
    }
}));